// compiler complains if using ToastSkin enum from WixUITpa library, opting to custom one

export enum ToastSkin {
  status = 'status',
  success = 'success',
  error = 'error',
  preview = 'preview',
}
